import React from 'react';
import {
    Container,
    FraudsContainer,
    HeadingContainer,
    MainHeading,
    Text,
    WhitePaperCta,
    Wrapper,
} from './identityFrauds.style';
import ArrowRight from '../../../../images/Icons/at_chevron-right.svg';
import IdFrauds from '../../components/IdFrauds';
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';

const IdentityFrauds = ({ heading, whitepaperPath, dataOne, dataTwo, whitepaperBtnDisable }) => {
    const isMobile = useMediaQuery('(max-width: 600px)');

    const textTransform = isMobile ? <>&mdash; </> : <br />;

    return (
        <Wrapper>
            <Container>
                <HeadingContainer>
                    <MainHeading>
                        {heading} {textTransform}
                        <span>Are You Protected?</span>
                    </MainHeading>
                    {/* temporary disabled */}
                    {!whitepaperBtnDisable && (
                        <WhitePaperCta to={whitepaperPath}>
                            <Text>Get Whitepaper</Text>
                            <img src={ArrowRight} alt="arrow-right" />
                        </WhitePaperCta>
                    )}
                </HeadingContainer>
                <FraudsContainer>
                    <IdFrauds data={dataOne} />
                    <IdFrauds data={dataTwo} reverse />
                </FraudsContainer>
            </Container>
        </Wrapper>
    );
};

IdentityFrauds.propTypes = {
    heading: PropTypes.string,
    whitepaperPath: PropTypes.string,
    dataOne: PropTypes.object,
    dataTwo: PropTypes.object,
    whitepaperBtnDisable: PropTypes.bool,
};

export default IdentityFrauds;
